import React from 'react';

import moment from 'moment';

import {
  ActionsRequisesDtoActionsRequisesEnum,
  DossierSummaryResponseDto,
} from 'lib_api/lib/api/gen/api';

import {
  ColumnProps,
  TableHeaderFunction,
} from 'components/WrappedComponents/Table/types';
import { SortOptions } from 'hooks/dossiers/useSearchDossierSummaries';
import { buildActionsRequisesContent } from 'utils/actionsRequisesUtils';
import { classementEnumMapping } from 'utils/enumData';
import { DATE_FORMAT } from 'utils/formats';
import {
  buildImmatriculationContent,
  buildStatutContent,
} from 'utils/TableUtils';

import DashboardHeader from '../DashboardHeader';
import { DashboardAdminFonctionnelFilter } from '../types';

export function buildColumns(
  url: string,
  adminActionsRequises?: ActionsRequisesDtoActionsRequisesEnum[] | undefined,
): ColumnProps<DossierSummaryResponseDto, SortOptions>[] {
  return [
    {
      title: 'Immatriculation',
      sortedField: SortOptions.IMMATRICULATION,
      buildCellContent: data => buildImmatriculationContent(url, data),
    },
    {
      title: "Date d'entrée",
      sortedField: SortOptions.DATE_MISE_FOURRIERE,
      buildCellContent: data =>
        data.ficheFourriere !== null &&
        data.ficheFourriere.dateMiseEnFourriere !== null
          ? moment(data.ficheFourriere.dateMiseEnFourriere).format(DATE_FORMAT)
          : null,
    },
    {
      title: 'Nature de mise en fourrière',
      sortedField: SortOptions.NATURE_MISE_EN_FOURRIERE,
      buildCellContent: data =>
        data.computed !== null && data.computed.brancheDto !== null
          ? data.computed.brancheDto.nature
          : null,
    },
    {
      title: 'Statut',
      sortedField: SortOptions.STATUT,
      buildCellContent: buildStatutContent,
    },
    {
      title: 'Classement',
      sortedField: SortOptions.CLASSEMENT,
      buildCellContent: data =>
        data.traitement && data.traitement.classement
          ? classementEnumMapping[data.traitement.classement].label
          : null,
    },
    {
      title: "Date d'ordre de destruction",
      sortedField: SortOptions.DATE_ORDRE_DESTRUCTION,
      buildCellContent: data =>
        data.traitement && data.traitement.dateOrdreDestruction !== null
          ? moment(data.traitement.dateOrdreDestruction).format(DATE_FORMAT)
          : null,
    },
    {
      title: 'Date de sortie définitive',
      sortedField: SortOptions.DATE_SORTIE_DEFINITIVE,
      buildCellContent: data =>
        data.sortie !== null && data.sortie.dateSortie !== null
          ? moment(data.sortie.dateSortie).format(DATE_FORMAT)
          : null,
    },
    {
      title: 'Fourrière',
      sortedField: SortOptions.FOURRIERE,
      buildCellContent: data =>
        data.computed?.fourriereDto?.raisonSociale || null,
    },
    {
      title: 'Action requise',
      sortedField: SortOptions.ACTIONS_REQUISES,
      buildCellContent: data =>
        buildActionsRequisesContent(url, data, adminActionsRequises),
    },
  ];
}

export const buildHeader: TableHeaderFunction<
  DossierSummaryResponseDto,
  DashboardAdminFonctionnelFilter
> = (fetchedData, _selectedData, filter, setFilter, sort) => (
  <DashboardHeader
    totalResult={fetchedData !== undefined ? fetchedData.total : 0}
    filter={filter}
    setFilter={setFilter}
    sort={sort}
  />
);
